import { render, staticRenderFns } from "./LinkButtonIcon.vue?vue&type=template&id=9b3c6f6a&scoped=true&"
import script from "./LinkButtonIcon.vue?vue&type=script&lang=ts&"
export * from "./LinkButtonIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LinkButtonIcon.vue?vue&type=style&index=0&id=9b3c6f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3c6f6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
